export default function UnsupportedBrowser() {
    return (
        <div>
            <h1>Unsupported Browser</h1>
        </div>
    )
}